import React from 'react';
import { Link } from 'gatsby';

const Footer = () => (
    <footer className="footer">
        <div className="container">
            <div className="columns">
                <div className="column">
                    Copyright © {new Date().getFullYear()}.
                    <p>https://josephkhan.me :)</p>
                </div>
                <div className="column has-text-centered-desktop">
                    <ul>
                        <li>About</li>
                        <li>Contact</li>
                        <li>Privacy Policy</li>
                    </ul>
                </div>
                <div className="column has-text-right-desktop">
                    <p>Facebook Page</p>
                    <p>Twitter Page</p>
                </div>
            </div>
        </div>
      </footer>
);

export default Footer;